module.exports = __webpack_public_path__ + "a05c11bfc8ff02126f04c7c55f804c23.ttf";